import React, { useEffect, useState, useCallback } from 'react'
import { Link, useLocation } from "react-router-dom";
import Menu from './Menu';
import { NavDropdown } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";

export default function Header({ headerClass, branchContent })  {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [currentMenu, setCurrentMenu] = useState([]);
  const [currentMenuKey, setCurrentMenuKey] = useState("default");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [modalShow, setModalShow] = useState(false);

  const [activeKey, setActiveKey] = useState("plat-tab1");

  const location = useLocation();

  //------ get discloure link
    const pathParts = location.pathname.split("/").filter(Boolean);
    const BranchName = pathParts[0] || "";

    const footerBranch =
      Object.entries(branchContent).find(([slug]) =>
        BranchName.includes(slug)
      )?.[1];

    const disclosureLink = footerBranch?.branch_slug
      ? `/${footerBranch.branch_slug}/disclosure`
      : "/disclosure";
  //------


  // All menus link list
  const menuData = {
    "lps-school-eldeco": {
      enquiryPath: "https://forms.edunexttechnologies.com/forms/lps/lpseld/enquiry/",
      menu: [
        { label: "About", path: "/lps-school-eldeco/manager-desk", icon: "/image/sectord-icon1.svg" },
        { label: "academics", path: "/lps-school-eldeco/academic-ethos", icon: "/image/sectord-icon2.svg" },
        { label: "pastoral", path: "/learning-support", icon: "/image/sectord-icon3.svg" },
        { label: "Admission", path: "/lps-school-eldeco/admission-process", icon: "/image/sectord-icon4.svg" },
        { label: "Disclosure", path: disclosureLink, icon: "/image/sectord-icon5.svg" },
      ],
    },

    "lps-school-ansal": {
      enquiryPath: "https://forms.edunexttechnologies.com/forms/lps/lpsansal/enquiry/",
      menu: [
        { label: "About", path: "/lps-school-ansal/manager-desk", icon: "/image/sectord-icon1.svg" },
        { label: "academics", path: "/lps-school-ansal/academic-ethos", icon: "/image/sectord-icon2.svg" },
        { label: "pastoral", path: "/learning-support", icon: "/image/sectord-icon3.svg" },
        { label: "Admission", path: "/lps-school-ansal/admission-process", icon: "/image/sectord-icon4.svg" },
        { label: "Disclosure", path: disclosureLink, icon: "/image/sectord-icon5.svg" },
      ],
    },

    "lps-school-sector-d": {
      enquiryPath: "https://forms.edunexttechnologies.com/forms/lps/lpssecd/enquiry/",
      menu: [
        { label: "About", path: "/lps-school-sector-d/manager-desk", icon: "/image/sectord-icon1.svg" },
        { label: "academics", path: "/lps-school-sector-d/academic-ethos", icon: "/image/sectord-icon2.svg" },
        { label: "pastoral", path: "/learning-support", icon: "/image/sectord-icon3.svg" },
        { label: "Admission", path: "/lps-school-sector-d/admission-process", icon: "/image/sectord-icon4.svg" },
        { label: "Disclosure", path: disclosureLink, icon: "/image/sectord-icon5.svg" },
      ],
    },

    "lps-school-sector-i": {
      enquiryPath: "https://forms.edunexttechnologies.com/forms/lps/lpsseci/enquiry/",
      menu: [
        { label: "About", path: "/lps-school-sector-i/manager-desk", icon: "/image/sectord-icon1.svg" },
        { label: "academics", path: "/lps-school-sector-i/academic-ethos", icon: "/image/sectord-icon2.svg" },
        { label: "pastoral", path: "/learning-support", icon: "/image/sectord-icon3.svg" },
        { label: "Admission", path: "/lps-school-sector-i/admission-process", icon: "/image/sectord-icon4.svg" },
        { label: "Disclosure", path: disclosureLink, icon: "/image/sectord-icon5.svg" },
      ],
    },

    "lps-school-jankipuram": {
      enquiryPath: "https://forms.edunexttechnologies.com/forms/lps/lpsjkp/enquiry/",
      menu: [
        { label: "About", path: "/lps-school-jankipuram/manager-desk", icon: "/image/sectord-icon1.svg" },
        { label: "academics", path: "/lps-school-jankipuram/academic-ethos", icon: "/image/sectord-icon2.svg" },
        { label: "pastoral", path: "/learning-support", icon: "/image/sectord-icon3.svg" },
        { label: "Admission", path: "/lps-school-jankipuram/admission-process", icon: "/image/sectord-icon4.svg" },
        { label: "Disclosure", path: disclosureLink, icon: "/image/sectord-icon5.svg" },
      ],
    },

    "lps-school-south-city": {
      enquiryPath: "https://forms.edunexttechnologies.com/forms/lps/lpsscity/enquiry/",
      menu: [
        { label: "About", path: "/lps-school-south-city/manager-desk", icon: "/image/sectord-icon1.svg" },
        { label: "academics", path: "/lps-school-south-city/academic-ethos", icon: "/image/sectord-icon2.svg" },
        { label: "pastoral", path: "/learning-support", icon: "/image/sectord-icon3.svg" },
        { label: "Admission", path: "/lps-school-south-city/admission-process", icon: "/image/sectord-icon4.svg" },
        { label: "Disclosure", path: disclosureLink, icon: "/image/sectord-icon5.svg" },
      ],
    },

    "lps-school-unnao-sector-b": {
      enquiryPath: "https://forms.edunexttechnologies.com/forms/lps/lpssecb/enquiry/",
      menu: [
        { label: "About", path: "/lps-school-unnao-sector-b/manager-desk", icon: "/image/sectord-icon1.svg" },
        { label: "academics", path: "/lps-school-unnao-sector-b/academic-ethos", icon: "/image/sectord-icon2.svg" },
        { label: "pastoral", path: "/learning-support", icon: "/image/sectord-icon3.svg" },
        { label: "Admission", path: "/lps-school-unnao-sector-b/admission-process", icon: "/image/sectord-icon4.svg" },
        { label: "Disclosure", path: disclosureLink, icon: "/image/sectord-icon5.svg" },
      ],
    },

    "lps-school-unnao-sector-c": {
      enquiryPath: "https://forms.edunexttechnologies.com/forms/lps/lpssecc/enquiry/",
      menu: [
        { label: "About", path: "/lps-school-unnao-sector-c/manager-desk", icon: "/image/sectord-icon1.svg" },
        { label: "academics", path: "/lps-school-unnao-sector-c/academic-ethos", icon: "/image/sectord-icon2.svg" },
        { label: "pastoral", path: "/learning-support", icon: "/image/sectord-icon3.svg" },
        { label: "Admission", path: "/lps-school-unnao-sector-c/admission-process", icon: "/image/sectord-icon4.svg" },
        // { label: "Disclosure", path: disclosureLink, icon: "/image/sectord-icon5.svg" },
      ],
    },

    "lps-school-ahiyaraipur": {
      enquiryPath: "https://forms.edunexttechnologies.com/forms/lps/lpsahr/enquiry/",
      menu: [
        { label: "About", path: "/lps-school-ahiyaraipur/manager-desk", icon: "/image/sectord-icon1.svg" },
        { label: "academics", path: "/lps-school-ahiyaraipur/academic-ethos", icon: "/image/sectord-icon2.svg" },
        { label: "pastoral", path: "/learning-support", icon: "/image/sectord-icon3.svg" },
        { label: "Admission", path: "/lps-school-ahiyaraipur/admission-process", icon: "/image/sectord-icon4.svg" },
        { label: "Disclosure", path: disclosureLink, icon: "/image/sectord-icon5.svg" },
      ],
    },

    "lps-school-pragatipuram": {
      enquiryPath: "https://forms.edunexttechnologies.com/forms/lps/lpspgr/enquiry/",
      menu: [
        { label: "About", path: "/lps-school-pragatipuram/manager-desk", icon: "/image/sectord-icon1.svg" },
        { label: "academics", path: "/lps-school-pragatipuram/academic-ethos", icon: "/image/sectord-icon2.svg" },
        { label: "pastoral", path: "/learning-support", icon: "/image/sectord-icon3.svg" },
        { label: "Admission", path: "/lps-school-pragatipuram/admission-process", icon: "/image/sectord-icon4.svg" },
        // { label: "Disclosure", path: disclosureLink, icon: "/image/sectord-icon5.svg" },
      ],
    },

    default: {
      enquiryPath: "/contact",
      menu: [
        { label: "Our Branches", path: "/", icon: "../image/header-icon1.svg" },
        { label: "Blogs", path: "/blog", icon: "../image/header-icon5.svg" },
        { label: "Media", path: "/news", icon: "../image/header-icon4.svg" },
      ],
    },
  };


   const handleToggleMenu = useCallback(() => setIsOpen((prev) => !prev), []);

   const handleScroll = useCallback(() => {
        const heightFromTop = window.scrollY;
        setIsSticky(heightFromTop > 0);
    }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);


// Change menu based on URL
useEffect(() => {
  const path = location.pathname.toLowerCase();
  let key = "default";

  if (path.includes("/lps-school-sector-d")) key = "lps-school-sector-d";
  else if (path.includes("/lps-school-eldeco")) key = "lps-school-eldeco"; 
  else if (path.includes("/lps-school-ansal")) key = "lps-school-ansal"; 
  else if (path.includes("/lps-school-sector-i")) key = "lps-school-sector-i"; 
  else if (path.includes("/lps-school-jankipuram")) key = "lps-school-jankipuram"; 
  else if (path.includes("/lps-school-south-city")) key = "lps-school-south-city"; 
  else if (path.includes("/lps-school-unnao-sector-b")) key = "lps-school-unnao-sector-b"; 
  else if (path.includes("/lps-school-unnao-sector-c")) key = "lps-school-unnao-sector-c"; 
  else if (path.includes("/lps-school-ahiyaraipur")) key = "lps-school-ahiyaraipur"; 
  else if (path.includes("/lps-school-pragatipuram")) key = "lps-school-pragatipuram"; 

  setCurrentMenu(menuData[key].menu);
  setCurrentMenuKey(key);
}, [location]);


const isDefaultEnquiry = currentMenuKey === "default";
const enquiryLink = menuData[currentMenuKey]?.enquiryPath || "/contact";

  return (
    <> 
    <header className={`header-area ${headerClass || ''} ${isSticky ? 'stick' : ''}`}>
        <div className="container">
            <div className="row align-items-center">

                <div className="col-lg-2 col-md-2 col-3">
                    <div className="logo">
                        <Link to={"/"}><img src="/image/logo.png" alt="Logo"/></Link>
                    </div>
                </div>

                <div className="col-lg-10 col-md-10 col-9">
                    <div className="topbar-menu">
                        <ul className="main-menu">
                          {currentMenu.map((item, index) => (
                          <li key={index} className={item.children ? "has-dropdown" : ""}>
                            {item.label === "Our Branches" ? (
                              <NavDropdown
                                  id="nav-dropdown-dark-example"
                                  title={<><img src={item.icon} alt="icon" /> {item.label}</>}
                                  menuVariant="light"
                                  show={dropdownOpen}
                                  onMouseEnter={() => setDropdownOpen(true)}
                                  onMouseLeave={() => setDropdownOpen(false)}
                                >
                                <div className="bigmenu-tabdata">
                                  <Tab.Container defaultActiveKey="plat-tab1" activeKey={activeKey} onSelect={setActiveKey}>
                                    <Nav className="bigmenu-tablink">
                                      <Nav.Item>
                                        <Nav.Link as={"div"} className="p-0" eventKey="plat-tab1" onMouseEnter={() => setActiveKey("plat-tab1")}>
                                          <div className='dropmenu-list'>
                                            <span>Lucknow</span>
                                            <ul>
                                              <li><Link to="lps-school-sector-d"><img src='../image/drop-icon3.webp' alt="icon"/>Sector D</Link></li>
                                              <li><Link to="lps-school-sector-i"><img src='../image/drop-icon4.webp' alt="icon"/>Sector I</Link></li>
                                              <li><Link to="lps-school-jankipuram"><img src='../image/drop-icon5.webp' alt="icon"/>Jankipuram</Link></li>
                                              <li><Link to="lps-school-south-city"><img src='../image/drop-icon6.webp' alt="icon"/>Southcity</Link></li>
                                              <li><Link to="lps-school-eldeco"><img src='../image/drop-icon2.webp' alt="icon"/>Eldeco II</Link></li>
                                              <li><Link to="lps-school-ansal"><img src='../image/drop-icon1.webp' alt="icon"/>Ansal API</Link></li>
                                            </ul>
                                          </div>
                                        </Nav.Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Nav.Link as={"div"} className="p-0" eventKey="plat-tab2" onMouseEnter={() => setActiveKey("plat-tab2")}>
                                          <div className='dropmenu-list'>
                                            <span>Raebareli</span>
                                            <ul>
                                              <li><Link to="lps-school-ahiyaraipur"><img src='../image/drop-icon3.webp' alt="icon"/>Ahiyaraipur</Link></li>
                                              <li><Link to="/lps-school-pragatipuram"><img src='../image/drop-icon1.webp' alt="icon"/>Pragatipuram</Link></li>
                                            </ul>
                                          </div>
                                        </Nav.Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Nav.Link as={"div"} className="p-0" eventKey="plat-tab3" onMouseEnter={() => setActiveKey("plat-tab3")}>
                                          <div className='dropmenu-list'>
                                            <span>Unnao</span>
                                            <ul>
                                              <li><Link to="/lps-school-unnao-sector-b"><img src='../image/drop-icon1.webp' alt="icon"/>Sector B</Link></li>
                                              <li><Link to="/lps-school-unnao-sector-c"><img src='../image/drop-icon2.webp' alt="icon"/>Sector C</Link></li>
                                            </ul>
                                          </div>
                                        </Nav.Link>
                                      </Nav.Item>
                                    </Nav>
      
                                    <Tab.Content className="bigmenu-tabcontent">
                                        <Tab.Pane eventKey="plat-tab1">
                                          <img src="/image/tabmenu-img1.webp" className="img-responsive radius-8" alt="state" loading="lazy" />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="plat-tab2">
                                          <img src="/image/tabmenu-img2.webp" className="img-responsive radius-8" alt="state" loading="lazy" />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="plat-tab3">
                                          <img src="/image/tabmenu-img3.webp" className="img-responsive radius-8" alt="state" loading="lazy" />
                                        </Tab.Pane>
                                    </Tab.Content>
                                  </Tab.Container>
                                </div>
                              </NavDropdown>
                            ) : (
                              <Link to={item.path}>
                                <img src={item.icon} alt="icon"/> {item.label}
                              </Link>
                            )}
                          </li>
                          ))}
                        </ul>

                        <Link to={enquiryLink} target={isDefaultEnquiry ? undefined : "_blank"}
                          rel={isDefaultEnquiry ? undefined : "noopener noreferrer"} className='default-btn red-default'>
                            <div><span>Enquire</span><span>Enquire</span></div>
                        </Link>

                        {/* <Link to={""} className='default-btn'>
                            <div><span>Log in</span><span>Log in</span></div>
                        </Link> */}

                        <div className="menu-toogle" onClick={handleToggleMenu}>
                            <div className="menu-line icon-top"></div>
                            <div className="menu-line icon-center"></div>
                            <div className="menu-line icon-bottom"></div>
                        </div>
                    </div>

                    {currentMenuKey === "default" && (
                    <div className="bottombar-menu">
                        <ul className="main-menu">
                          <li><Link to={"/our-heritage"}>About</Link></li>
                          <li><Link to={"/admission-process"}>Admissions</Link></li>
                          <li><Link to={"/why-lps-lucknow-public-school"}>why LPS</Link></li>
                          <li><Link to={"/values"}>Values</Link></li>
                          <li><Link to={"/parents"}>parents</Link></li>
                        </ul>
                    </div>
                    )}
                </div>

            </div>
        </div>
    </header>

    <Menu isOpen={isOpen} setIsOpen={setIsOpen}/>
    </>
  )
}
